// AuthCallback.js

import { useEffect } from "react";
import { getCurrentUser, fetchUserAttributes } from "@aws-amplify/auth";
import { useNavigate } from "react-router-dom";

export default function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    const completeLogin = async () => {
      try {
        const user = await getCurrentUser();
        const attributes = await fetchUserAttributes();

        // Same routing logic as login.js
        if (attributes["custom:firstname"]) {
          navigate("/authorportal/mainpage");
        } else {
          navigate("/readerportal");
        }
      } catch (err) {
        console.error("OAuth login failed:", err);
        navigate("/login");
      }
    };

    completeLogin();
  }, [navigate]);

  return null; // no UI needed
}
